// extracted by mini-css-extract-plugin
export var attachment = "_q7-a";
export var emailContainer = "_q7-4";
export var emailContentPaddedContainer = "_q7-b";
export var emailHeader = "_q7-6";
export var emailIframe = "_q7-3";
export var emailInfoIcon = "_q7-9";
export var emailShortenedSummary = "_q7-e";
export var infoDropdown = "_q7-0";
export var infoRowBoundedContent = "_q7-d";
export var internal = "_q7-5";
export var merchant = "_q7-8";
export var messageInputContainer = "_q7-h";
export var normal = "_q7-7";
export var replyCard = "_q7-f";
export var subtleButton = "_q7-1";
export var subtleButtonIconContainer = "_q7-2";
export var toggleViewRepliesButton = "_q7-c";
export var wrappingText = "_q7-g";